import { Code, ConnectError } from '@connectrpc/connect';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../contexts/authContext';
import { registryRecordClient } from '../registryRecordClient';
export const companyKeys = {
    dossier: (viewer, id)=>[
            'registry',
            'company',
            viewer,
            id,
            'dossier'
        ],
    rates: (viewer, id, vehicle)=>[
            'registry',
            'company',
            viewer,
            id,
            'rates',
            vehicle
        ],
    people: (viewer, id)=>[
            'registry',
            'company',
            viewer,
            id,
            'people'
        ]
};
export function useCompany(id, vehicleId) {
    const { user } = useAuth();
    const viewer = `${user?.tenant_id ?? ''}:${user?.id ?? ''}`;
    const enabled = !!user?.tenant_id && !!user?.id && !!id;
    const dossier = useQuery({
        queryKey: companyKeys.dossier(viewer, id),
        enabled,
        retry: false,
        queryFn: async ()=>{
            try {
                return await registryRecordClient.getCompanyDossier({
                    companyId: id
                });
            } catch (error) {
                if (error instanceof ConnectError && [
                    Code.NotFound,
                    Code.PermissionDenied
                ].includes(error.code)) return null;
                throw error;
            }
        }
    });
    const relatedEnabled = enabled && !!dossier.data;
    const rates = useQuery({
        queryKey: companyKeys.rates(viewer, id, vehicleId),
        enabled: relatedEnabled,
        retry: false,
        queryFn: ()=>registryRecordClient.getCompanyRateBook({
                companyId: id,
                vehicleId,
                includeUnmapped: true
            })
    });
    const people = useQuery({
        queryKey: companyKeys.people(viewer, id),
        enabled: relatedEnabled,
        retry: false,
        queryFn: ()=>registryRecordClient.listOrganizationPeople({
                employerKind: 'COMPANY',
                employerId: id,
                includePast: true
            })
    });
    return {
        dossier,
        rates,
        people
    };
}
